import { render, staticRenderFns } from "./MiniWizardStickyHeader.vue?vue&type=template&id=5fd612f7&"
import script from "./MiniWizardStickyHeader.vue?vue&type=script&lang=js&"
export * from "./MiniWizardStickyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports